import { Avatar, Button, Grid, Paper, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import logoWhite from '../assets/logo-icon-white.png'
import { MobileNumberValidation } from '../utils/MobileNumberCheck';
import { setAuth, setAuthenticationToken } from '../utils/TokenHandler';
import axios from 'axios';
import MaterialNotifyComponent from './MaterialNotifyComponent';
import headerLogo from '../assets/Logo_login.png';
import drailLogo from '../assets/Dreil.png';
import colors from 'react-multi-date-picker/plugins/colors';

let timer;

function LoginByMobile(props) {
    const mainDivStyle = {
        margin: '0',
        textAlign: 'center',
        backgroundColor: '#0072bc',
        color: 'white',
        width: '100%',
        minHeight: '100vh'
    };
    const headerDivStyle = {
        backgroundColor: '#ffffff',
        height: '50px',
        display: 'flex'
    };
    const leftHeaderSection = {
        display: "inline",
        width: "50%",
        height: "50px",
        borderTopRightRadius: "40px",
        backgroundImage: "linear-gradient(60deg, #ffffff, #eeeeee, #cccccc)"
    };
    const centerHeaderSection = {
        display: ["inline", "inline-flex"],
        width: "400px",
        height: "50px",
        color: "#0072bc",
        alignItems: "center"
    };
    const centerHeaderText = { margin: 'auto' };
    const rightHeaderSection = {
        display: "inline",
        width: "50%",
        height: "50px",
        borderTopLeftRadius: "40px",
        backgroundImage: "linear-gradient(-60deg, #ffffff, #eeeeee, #cccccc)"
    };
    const headerLogoSection = { background: "#0072bc", height: "100px", display: "flex" };
    const headerLogoSideSection = { display: "inline", width: "50%", height: "100px" };
    const headerLogoCenterSection = {
        display: ["inline", "inline-flex"],
        background: "#ffffff",
        width: "400px",
        height: "100px",
        borderRadius: "0px 0px 20px 20px",
        alignItems: "center"
    };
    const logoImage = {
        width: "90%",
        display: "inline-block",
        margin: "auto",
        verticalAlign: "middle"
    };
    const headerText = {
        alignItems: "center",
        direction: "rtl",
        lineHeight: "0.7rem"
    };
    const headerEnglishText = { fontFamily: "Verdana, Geneva, Tahoma, sans-serif", fontSize: "19px" };
    const headerPersianText = { fontSize: "23px" };
    const headerPersianTextNumber = { color: "yellow", fontWeight: "bolder" };
    const dreilContainer = {
        height: "260px",
        display: "inline-flex",
        alignItems: "center"
    };
    const dreilImage = {
        width: "200px",
        display: "inline-block",
        margin: "auto",
        verticalAlign: "middle"
    };
    const buttonStyle = { color: '#ffffff' };
    const paperStyle = {
        padding: 20,
        width: 250,
        margin: 'auto',
        overflow: 'auto',
        backgroundColor: 'transparent !important'
    };

    const avatarStyle = {
        background: '#2e3192',
        width: '100px',
        height: '100px'
    };

    const imgStyle = {
        width: "70px",
        height: '70px'
    };

    const formElementStyle = {
        margin: "10px 0",
        backgroundColor: '#0072bc'
    };

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0, // or black
                left: 'unset',
                color: '#ffffff'
            },
            "& .MuiInputLabel": {
                color: '#ffffff'
            },
            '& .MuiInput-root::after': {
                borderBottom: '2px solid #ffffff'
            },
            '& .MuiInputBase-input-MuiInput-input': {
                color: '#ffffff'
            },
            '& .Mui-focused': {
                color: '#ffffff !important'
            }
        }
    }));

    const classes = useStyles();

    //State----------------------------------------------------------------------------------
    const [mobileNumber, setMobileNumber] = useState('');
    const [userName, setUserName] = useState('');
    const [confirmCode, setConfirmCode] = useState('');
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [sendCodeAgain, setSendCodeAgain] = useState(180);
    //---------------------------------------------------------------------------------------

    const loginHandler = (e) => {
        axios.post('api/v2/Authorization/ConfirmSMS', null, {
            params: {
                mobileNumber: mobileNumber,
                confirmCode: confirmCode,
                IsFromWeb: true
            }
        }).then(response => {
            if (response.data && response.data.access_token !== "Wrong Code") {
                setAuthenticationToken(response.data);
                setAuth(response.data.access_token);
                props.history.push('/');
            }
            else if (response.data.access_token === "Wrong Code") {
                setMessageNotify({
                    severity: "warning",
                    message: "کد وارد شده صحیح نمی باشد",
                    open: true
                });
            }
            else {
                setMessageNotify({
                    severity: "error",
                    message: "خطا در ورود به باشگاه",
                    open: true
                });
            }
        }).catch(e => {
            setMessageNotify({
                severity: "error",
                message: "خطا در ورود به باشگاه",
                open: true
            });
        });
    }

    const sendCode = (e) => {
        let mobileObject = MobileNumberValidation(userName);
        if (mobileObject.isValid) {
            axios.get('api/v2/Authorization/MobileDirectLogin', {
                params: {
                    phoneNumber: mobileObject.validNumber,
                    isFromAPP: false
                }
            }).then(res => {
                if (res.data.requiredConfirm) {
                    timer = window.setInterval(() => {
                        setSendCodeAgain(prevTime => {
                            if (prevTime <= 1) {
                                window.clearInterval(timer);
                            }
                            return prevTime - 1
                        });
                    }, 1000);
                    setMobileNumber(mobileObject.validNumber);
                } else {
                    setMessageNotify({
                        severity: "error",
                        message: "خطا در ورود به باشگاه",
                        open: true
                    });
                }
            }).catch(e => {
                setMessageNotify({
                    severity: "error",
                    message: "خطا در ورود به باشگاه",
                    open: true
                });
            })
        }
        else {
            setMessageNotify({
                severity: "warning",
                message: "شماره تلفن همراه به صورت صحیح وارد نشده است",
                open: true
            });
        }
    }

    const MobileConmponent = <>
        <TextField type="number" value={confirmCode} onChange={e => setConfirmCode(e.target.value)} style={formElementStyle} className={classes.root} placeholder="کد فعال سازی را وارد کنید" label="کد فعال سازی" variant="standard" required fullWidth />
        <Button onClick={loginHandler} style={formElementStyle} type="submit" variant="contained" fullWidth>ورود</Button>
        {(sendCodeAgain === 0 ? <Button style={{ color: '#000000' }} onClick={(e) => { setSendCodeAgain(180); sendCode(e); }} variant="text" fullWidth>ارسال مجدد کد فعال سازی</Button> : <h5 style={{ textAlign: 'center' }}>{Math.floor(sendCodeAgain / 60) + ':' + (sendCodeAgain % 60)}</h5>)}
    </>;

    const ConfirmCodeConmponent = <>
        <TextField value={userName} onChange={e => setUserName(e.target.value)} style={formElementStyle} className={classes.root} placeholder="نام کاربری(شماره موبایل) را وارد کنید" label="نام کاربری(شماره موبایل)" variant="standard" required fullWidth />
        <Button onClick={sendCode} style={formElementStyle} type="submit" variant="contained" fullWidth>دریافت کد</Button>
    </>;

    return (
        <>
            <div style={mainDivStyle}>
                <div style={headerDivStyle}></div>
                <div style={headerDivStyle}>
                    <div style={rightHeaderSection}></div>
                    <div style={centerHeaderSection}>
                        <b style={centerHeaderText}>ابزار آلات صنعتی اِن ای سی</b>
                    </div>
                    <div style={leftHeaderSection}></div>
                </div>
                <div style={headerLogoSection}>
                    <div style={headerLogoSideSection}></div>
                    <div style={headerLogoCenterSection}>
                        <img src={headerLogo} style={logoImage} />
                    </div>
                    <div style={headerLogoSideSection}></div>
                </div>
                <div style={headerText}>
                    <p style={headerEnglishText}>PROFETIONAL TOOLS</p>
                    <p style={headerPersianText}><span style={headerPersianTextNumber}>۲۴</span> ماه گارانتی نا محدود</p>
                </div>
                <div style={dreilContainer}>
                    <img style={dreilImage} src={drailLogo} />
                </div>
                <Grid>
                    <div style={paperStyle}>
                        {mobileNumber ? MobileConmponent : ConfirmCodeConmponent}
                        <Button style={buttonStyle} onClick={e => { props.history.push('/login') }} variant="text" fullWidth>ورود با نام کاربری و کلمه عبور</Button>
                    </div>
                </Grid>
                <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
                <div style={{
                    display: 'flex',
                    justifyContent: 'center'
                }}><span style={{ alignSelf: 'flex-end', alignContent: 'center' }}>www.<span style={{ color: 'darkblue' }}>NEC</span>tools.ir</span></div>
            </div>
        </>)
}

export default LoginByMobile;